module.exports = __webpack_public_path__ + "static/images/p4_grey.2ba18a3.png";